// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1081":"dist/css/editor","6805":"dist/css/style"}[chunkId] + ".css";
};